function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "7dv5aw1ikc",
  x1: "35.152%",
  x2: "121.5%",
  y1: "66.505%",
  y2: "-100.5%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6A2D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A93D69"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#7dv5aw1ikc)",
  d: "M11 2c.55 0 1.05.22 1.41.58l9 9c.36.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59-.55 0-1.05-.22-1.41-.58l-9-9C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2zm0 1.99V4H4v7l9 9.01 7-7.02-9-9zM6.5 5C7.328 5 8 5.672 8 6.5S7.328 8 6.5 8 5 7.328 5 6.5 5.672 5 6.5 5z"
});
const SvgNewProductGroupPricing = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProductGroupPricing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-product-group-pricing.e0537497.svg";
export { ForwardRef as ReactComponent };